import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWixComponent } from './simple-icons-wix.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWixComponent ],
    exports:      [ SimpleIconsWixComponent ],
    bootstrap:    []
})
export class SimpleIconsWixModule {}
